import styled from "styled-components";
import bgImg from "../../../../assets/images/kotib/2.png";

export const InnerRightDiv = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const RightButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  .download-btn {
    display: flex;
    justify-content: center ;
    align-items: center;
    gap: 15px;
  }
`;

export const StatisticDiv = styled.div`
  margin: 20px 0;
`;

export const VotesDiv = styled.div`
  height: 350px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  margin-top: 25px;
  padding: 30px;
  padding-left: 0;
  border-radius: 12px;
  background-image: url(${bgImg});
  background-position: top 0 right 0;
  background-repeat: no-repeat;
  background-size: 250px;
  background-color: #f6fcff;

  h3 {
    margin: 0;
    color: #208667;
  }

  p {
    margin: 0;
    margin-top: 10px;
    font-size: 13px;
    font-weight: 600;

    span {
      color: #208667;
    }
  }

  h5 {
    margin: 0;
  }
`;
